// ----------------------------------------------------------------------
// <copyright file="Izenda.WorkspaceDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Workspace Data Fetcher.
 */

import fetch from 'share/fetch/Izenda.Fetch';

const ROOT = 'copyManagement/';

export default {
  /*
    * Load list of workspaces
    * @returns {promise}
    */
  getAllWorkspaces(showOnlyMyWorkspace = false) {
    const tenantId = 'null';
    return fetch(`${ROOT}workspaces/${tenantId}/${showOnlyMyWorkspace}`).get();
  },

  getAvailableSources() {
    return null;
  },

  /**
     * [getWorkspaceDetail get workspace detail information]
     * @param  {[string]} workspaceId
     * @return {[object]}
     */
  getWorkspaceDetail(workspaceId) {
    workspaceId = workspaceId || 'null';
    return fetch(`${ROOT}workspace/${workspaceId}`).get();
  },

  /**
     * Delete a workspace by its id
     * @param {string} workspaceId
     * @returns {promise}
     */
  delete(workspaceId) {
    return fetch(`${ROOT}workspace/${workspaceId}`).delete();
  },

  /**
     * [saveWorkspaceDetail save workspace with the detail]
     */
  saveWorkspaceDetail(data) {
    return fetch(ROOT).post(data);
  },

  /**
     * Load destination connections
     * @param {Object} tenant
     * @returns {promise}
     */
  loadDestinationConnections(data) {
    return fetch(`${ROOT}workspace/loadDestinationConnections/`).post(data);
  },

  /**
     * validate Workspace Tenant
     * @param  {[object]} {workspaceTenant, mappings}
     * @returns {promise}
     */
  validateWorkspaceTenant(data) {
    return fetch(`${ROOT}workspace/validateWorkspaceTenant`).post(data);
  },

  /**
     * Load connection by list tenants
     * @param {Array} tenants
     * @returns {promise}
     */
  loadDistinctConnections(tenants) {
    const data = {
      tenantIds: tenants
    };
    return fetch('connection/loadDistinctConnections/').post(data);
  },

  /**
     * validate WorkspaceName
     * @param  {object} data 
     * @return {promise}      
     */
  validateWorkspaceName(data) {
    return fetch(`${ROOT}workspace/validateName`).post(data);
  },

  /**
     * check Connection Has Data Model
     * @param  {[array]} data 
     * @return {promise}     
     */
  checkConnectionHasDataModel(data) {
    return fetch(`${ROOT}connectionsHasDataModel`).post(data);
  },

  /**
     * detect Conflicting Role Permission
     * @param  {[array]} data 
     * @return {promise}     
     */
  detectConflictingRolePermission(data) {
    return fetch(`${ROOT}workspace/detectConflictingRolePermission`).post(data);
  },

  /**
     * detect Conflicting Tenant Permissions
     * @param  {[array]} data 
     * @return {promise}      
     */
  detectConflictingTenantPermissions(data) {
    return fetch(`${ROOT}workspace/detectConflictingTenantPermissions`).post(data);
  },

  /**
     * detect Conflicting Advanced Settings
     * @param  {[array]} data 
     * @return {promise}   
     */
  detectConflictingAdvancedSettings(data) {
    return fetch(`${ROOT}workspace/detectConflictingAdvancedSettings`).post(data);
  },

  /**
     * detect conflicting dashboards
     * @param  {[array]} data 
     * @return {promise}   
     */
  detectConflictingDashboards(data) {
    return fetch(`${ROOT}workspace/detectConflictingDashboard`).post(data);
  },

  /**
     * detect conflicting report
     * @param  {[array]} data 
     * @return {promise}   
     */
  detectConflictingReports(data) {
    return fetch(`${ROOT}workspace/detectConflictingReport`).post(data);
  },

  /**
     * detect conflicting template
     * @param  {[array]} data 
     * @return {promise}   
     */
  detectConflictingTemplates(data) {
    return fetch(`${ROOT}workspace/detectConflictingTemplate`).post(data);
  },

  /**
     * [runCopy description]
     * @param  {[object]} data [WorkspaceDetail]
     * @return {[object]} 
     */
  runCopy(data) {
    return fetch(`${ROOT}copy`).post(data);
  }
};



// WEBPACK FOOTER //
// ./ui/fetchers/Izenda.WorkspaceDataFetcher.js